import React from "react";
import emailjs from "emailjs-com";

class MailSender {
  static async sendMail(data) {
    emailjs
      .send(
        "smtp.sendgrid.net",
        "ВАШ_ШАБЛОН_ID",
        {
          to_email: "artem@gmail.com",
          from_name: "artem@gmail.com",
          message_html: "тест",
        },
        "ВАШ_ІДЕНТИФІКАТОР_КОРИСТУВАЧА"
      )
      .then(
        (response) => {
          console.log(
            "Лист успішно надіслано!",
            response.status,
            response.text
          );
          alert("Лист успішно надіслано!");
        },
        (error) => {
          console.error("Помилка надсилання листа:", error);
          alert("Помилка надсилання листа:", error);
        }
      );
  }
}

export { MailSender };
